import React from "react";
import { useRecoilState } from "recoil";
import { dvrTypeReFetching } from "../atoms/atoms";
import { deleteDVRType } from "actions/Utilities/DVRType";
import { useMutation } from "react-query";
import { toast } from "components/toastNotification";

export default function useDeleteDVRType() {
  const [isReFetching, setIsReFetching] = useRecoilState(dvrTypeReFetching);

  const { mutate } = useMutation((ids: number[]) => deleteDVRType(ids), {
    onSuccess: (res: any) => {
      if (typeof res == "object") {
        toast.fire("Disabling DVR Type failed", res.Message, "error");
      } else {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "DVR Type Disabled Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `DVR Type Disabled Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Disabling DVR Type failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "DVR Type not found":
            toast.fire("Disabling DVR Type failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Disabling DVR Type failed", res, "error");
        }
      }
      // ReFetch Data
      setIsReFetching(isReFetching ? false : true);
    },
    onError: (error) => {
      toast.fire("Disabling DVR Type failed", `Error: ${error}`, "error");
    },
  });

  return mutate;
}
